import { actionTypes as resourceActions } from 'redux-resource';
import { createFormAction } from 'redux-form-saga';
import * as types from './types';

export const getAll = (userId) => ({
  type: types.GET_ALL,
  payload: { userId },
});

/*
 * Set Default card actions
 */
export const setDefault = (id) => ({
  type: types.SET_DEFAULT,
  payload: { id }
});

// lol
const setDefaultDefaults = {
  resourceType: 'paymentMethods',
  requestKey: 'setDefault'
}

export const setDefaultPending = (id) => ({
  ...setDefaultDefaults,
  type: resourceActions.UPDATE_RESOURCES_PENDING,
  resources: [id]
});

export const setDefaultSucceeded = (resp) => ({
  ...setDefaultDefaults,
  type: resourceActions.UPDATE_RESOURCES_SUCCEEDED,
  resources: [resp.data]
});

export const setDefaultFailed = (id) => ({
  ...setDefaultDefaults,
  type: resourceActions.UPDATE_RESOURCES_FAILED,
  resources: [id]
});

/*
 * Create card actions
 */
export const create = createFormAction(types.CREATE);
/*
export const create = (attr) => ({
  type: types.CREATE,
  payload: { attr }
});
*/

const createDefaults = {
  resourceType: 'paymentMethods',
  requestKey: 'create'
}

export const createPending = () => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING
});

export const createSucceeded = (response) => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data]
});

export const createFailed = () => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED
});

/*
 * Destroy card actions
 */
export const destroy = (userId, cardId) => ({
  type: types.DESTROY,
  payload: { userId, cardId }
});

const destroyDefaults = {
  resourceType: 'paymentMethods',
  requestKey: 'destroy'
}

export const destroyPending = (id) => ({
  ...destroyDefaults,
  type: resourceActions.DELETE_RESOURCES_PENDING,
  resources: [id]
});

export const destroySucceeded = (id) => ({
  ...destroyDefaults,
  type: resourceActions.DELETE_RESOURCES_SUCCEEDED,
  resources: [id]
});

export const destroyFailed = (id) => ({
  ...destroyDefaults,
  type: resourceActions.DELETE_RESOURCES_FAILED,
  resources: [id]
});
